export const isTTSSupported = () => {
    return 'speechSynthesis' in window;
};

/* Filters out backend system messages so they aren't spoken in Voice Mode */
const BLOCKED_PHRASES = [
    "⏳ Working on it—this model thinks more deeply, so it may take a moment.",
    "One moment while I analyze that...",
    "Let me dig into the details for you...",
    "Processing your request...",
    "Checking the data sources...",
    "I'll handle it now! Just a moment while I locate, evaluate, and condense the data you need...",
];

export const speak = (text) => {
    if (!isTTSSupported()) return;

    // Filter out canned responses
    let cleanText = text;
    BLOCKED_PHRASES.forEach(phrase => {
        // Create a regex to replace the phrase globally, ignoring case if needed (though exact match is safer for these specific strings)
        // We trim the phrase to match flexible whitespace if it occurs at start/end of lines
        cleanText = cleanText.split(phrase.trim()).join('');
    });

    // Also remove the specific emoji if it's left over
    cleanText = cleanText.replace(/⏳/g, '');

    cleanText = cleanText.trim();
    if (!cleanText) return;

    // Cancel any current speaking
    window.speechSynthesis.cancel();

    const utterance = new SpeechSynthesisUtterance(cleanText);

    // Optional: Select a voice (prefer English)
    const voices = window.speechSynthesis.getVoices();
    const englishVoice = voices.find(voice => voice.lang.startsWith('en-') && !voice.name.includes('Google'));
    if (englishVoice) {
        utterance.voice = englishVoice;
    }

    utterance.rate = 1.0; // Normal speed
    utterance.pitch = 1.0; // Normal pitch

    window.speechSynthesis.speak(utterance);
};

export const stopEx = () => {
    if (isTTSSupported()) {
        window.speechSynthesis.cancel();
    }
}
